<template>
    <section>
    <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" align="left" style="text-align: left">
            <el-form-item>
                <el-input v-model="formInline.Keyword" placeholder="Language" @keyup.enter.native=''></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 120px" icon="el-icon-search" @click.native.prevent="queryLanguage">查找</el-button>
            </el-form-item>
            <el-form-item>
                <el-popover
                        placement="bottom"
                        title="可支持的语言"
                        width="200"
                        trigger="click"
                        :content="supportedLanguages">
                    <el-button slot="reference" icon="el-icon-document" style="width: 120px" @click.native.prevent="getSupportedLang">可支持语言</el-button>
                </el-popover>
                <!--el-button icon="el-icon-document" style="width: 120px" @click.native.prevent="getSupportedLang">可支持语言</el-button-->
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-edit" style="width: 120px" @click.native.prevent="showEditDialog">添加语言</el-button>
            </el-form-item>
        </el-form>
    </el-col>
    <!--列表-->
    <template>
        <el-table :data="languageData" highlight-current-row  style="width: 100%;" stripe ><!-- @row-click="editLanguage"-->
            <el-table-column prop="Language" label="Language" width="200" sortable></el-table-column>
            <el-table-column prop="Description" label="Description" width="400" sortable></el-table-column>
            <el-table-column prop="Action" label="操作" width="200">
                <template slot-scope="scope">
                    <!--el-button @click="editLanguage(scope.row)" v-show="seen()" type="primary" size="mini" style="width: auto" icon="el-icon-edit"></el-button-->
                    <el-button @click="deleteLanguage(scope.row)" v-show="seen()" type="danger" size="mini" icon="el-icon-delete" style="width: auto"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </template>
    <!--分页-->
    <el-col :span="24" class="toolbar" style="padding-bottom:10px;">
        <el-pagination :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="totaltotal"
                       v-on:current-change="pageIndexChange" v-on:size-change="sizeChange" style="float:none">
        </el-pagination>
    </el-col>
    <!--编辑界面-->
    <el-dialog width='450px' :title="editFormTitle" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="languageForm" label-width="110px" ref="languageForm" :rules="langFormRules">
            <el-form-item label="Language:" prop="Language">
                <el-input class="dialog_input" v-model="languageForm.Language" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Description:" prop="Description">
                <el-input class="dialog_input" v-model="languageForm.Description" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button style="width: 80px;" @click.native="cancelEdit('languageForm')">取消</el-button>
            <el-button style="width: 80px;" type="primary" @click.native="submitEdit('languageForm')" >提交</el-button>
        </div>
    </el-dialog>
    </section>
</template>
<script>
    import { Config } from "@/config/config"
    import { addLanguage, deleteLanguage } from "@/api/language"
    import { mapState } from 'vuex'
    import Notify from '../../api/notifyMsg'

    export default {
        computed: mapState({
            user: state => state.user
        }),
        data() {
            return {
                languageForm: {
                    Id: '',
                    Language: '',
                    Description: ''
                },
                formInline: {
                    Keyword: ''
                },
                tableJsonData: [],
                listLoading: false,
                supportedLanguages: "de-DE, en-AU, en-CA, en-GB, en-IN, en-US, es-ES, es-MX, fr-FR, ja-JP",
                editFormTitle: "语言详情",
                languageData: [{Language:"en-GB", Description:"English (United Kingdom)"}],
                currentTableData: [],
                //areaData: [{Area:"UK", Domain:"EU", AlexaServer:"avs-alexa-eu.amazon.com", AreaServer:"ai.tclking.com", AvsStatus:"enable", WwaStatus:"enable"}],
                editFormVisible: false,
                editLoading: false,
                pageIndex: 1,
                pageSizes: [10, 20, 30, 40, 50],
                pageSize: 10,
                totaltotal: 0,
                langFormRules: {
                    Language: [{
                        required: true, message: '请输入Language Name',trigger: 'blur'
                    }],
                    Description: [{
                        required: true, message: '请输入Language Description', trigger: 'blue'
                    }],
                },
                languageApiUrl: '/api/v1/console/language',
            };
        },
        methods: {
            seen() {
                if(this.user.Role !== "admin") {
                    return false;
                } else {
                    return true;
                }
            },
            getData: function () {
                var _this = this;
                _this.languageData = [];
                var offset = (_this.pageIndex-1) * _this.pageSize;
                var keyword = _this.formInline.Keyword;
                console.log("getData keyowrd:", keyword)
                fetch(Config.url + _this.languageApiUrl + "?offset=" + offset + "&limit=" + _this.pageSize + "&keyword=" + keyword + "&token=" + _this.user.token)
                    .then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json.Error_code === 1000) {
                            var i;
                            for (i = 0; i < json.languages.length; i++) {
                                var language = json.languages[i].language;
                                var description = json.languages[i].description;
                                _this.$set(_this.languageData, i, new _this.showLanguage(language, description));
                            }
                            _this.totaltotal = json.count;
                            //_this.pagination()
                        } else {
                            Notify.errMsgNotify(json.Error_code, _this)
                            return
                        }
                    })
            },
            /*pagination() {
                 this.currentTableData = [];
                 var startIndex = (this.pageIndex - 1) * this.pageSize
                 var currentPageMaxItemsSize = ((startIndex + this.pageSize) > (this.totaltotal - startIndex)) ? (this.totaltotal - startIndex) : (startIndex + this.pageSize)
                 for (var a = startIndex, b = 0; a < currentPageMaxItemsSize + startIndex, b < currentPageMaxItemsSize; a++, b++) {
                    this.currentTableData[b] = this.languageData[a]
                 }
             },*/
            showLanguage: function(language,description) {
                this.Language = language;
                this.Description = description;
            },
            queryLanguage: function () {
                var _this = this;
                _this.getData();
            },
            getSupportedLang: function () {

            },
            editLanguage: function (row, event, column) {
                var _this = this
                if(column !== undefined && column.property === "Action") {
                    return;
                }
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                _this.editFormTitle = '修改语言';
                _this.editType=0;
                _this.editFormVisible = true;

                _this.languageForm.Language = row.Language;
                _this.languageForm.Description = row.Description;
            },
            deleteLanguage: function (row) {
                var _this = this;
                _this.$confirm('确认删除吗？', '提示', {}).then(() => {
                    deleteLanguage(row.Language, _this.user.token)
                        .then(response => {
                            console.log(response)
                            if (response.data.Error_code === 1000) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功！'
                                });
                                _this.languageData = [];
                                _this.getData();
                            } else {
                                /*_this.$message({
                                type: 'fail',
                                message: '删除失败，请重试。'
                            })*/
                            Notify
                                .errMsgNotify(response.data.Error_code, _this)
                        }
                        })
                });
            },
            modifyLanguage: function(form) {
                console.log("modifyLanguage");
            },
            addLanguage: function (form) {
                console.log(" addLanguage ", form);
                var _this = this;
                var language = _this.languageForm.Language;
                var description = _this.languageForm.Description

                var i = 0;
                for (; i < _this.languageData.length; i ++) {
                    if(_this.languageData[i].Language.toLowerCase() === language.toLowerCase()) {
                        _this.$message({
                            message: '该语言已经存在！',
                            type: 'fail'
                        });
                        return
                    }
                }

                addLanguage(language, description, _this.user.token)
                    .then(response => {
                        console.log(response)
                        if (response.data.Error_code === 1000) {
                            _this.$message({
                                type: 'success',
                                message: '添加成功！'
                            });
                            _this.getData();
                        } else {
                            /*_this.$message({
                                type: 'fail',
                                message: '添加失败，请重试。'
                            })*/
                            Notify.errMsgNotify(response.data.Error_code, _this)
                        }
                    })
                _this.editFormVisible = false;
            },
            cancelEdit: function(formName) {
                var _this = this;
                _this.editFormVisible = false;
                _this.$refs[formName].resetFields();
            },
            submitEdit: function() {
                var _this = this;
                _this.$refs.languageForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            _this.editLoading = true;
                            _this.btnEditText = '提交中';
                            if(_this.editType === 1)
                                _this.modifyLanguage(_this.areaForm);
                            else
                                _this.addLanguage(_this.areaForm);
                            setTimeout(function() {
                                _this.editLoading = false;
                                //NProgress.done();
                                _this.btnEditText = '提 交';
                                _this.editFormVisible = false;
                            }, 1000);
                        });
                    }
                });
            },
            showEditDialog: function () {
                console.log("showEditDialog ", this.editFormVisible)
                var _this = this;
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                _this.editFormTitle = '添加语言';
                _this.editFormVisible = true;
                _this.editType = 0;

                _this.languageForm.Language = '';
                _this.languageForm.Description = '';
            },
            pageIndexChange: function(pageIndex) {
                var _this = this
                _this.pageIndex = pageIndex
                _this.getData()
            },
            sizeChange: function(pageSize) {
                var _this = this
                _this.pageSize = pageSize
                _this.getData()
            },
        },
        mounted: function() {
            this.getData();
        },
    }
</script>
<style scoped>
    .toolbar {
        background: #fff;
        /*padding: 10px 10px 0px 10px;*/
    }

    .dialog_input {
        width: 87%;
    }
</style>


// WEBPACK FOOTER //
// src/components/area/LanguageManage.vue